var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 163",
    width: 170,
    height: 163,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-791-857h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9ebff}.b{fill:#ce7602}.c{fill:#2f4a7f}.d{fill:#e2877a}.e{fill:#162e4c}.f{fill:#efac37}.g{fill:#e8615b}.h{fill:#c13533}.i{fill:#7db6f9}.j{fill:#476b9e}.k{fill:#b3d6ff}.l{fill:#f4a798}.m{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m170 155.1c0 4.1-37.9 7.4-84.5 7.4-46.7 0-84.5-3.3-84.5-7.4 0-4.1 37.8-7.5 84.5-7.5 46.6 0 84.5 3.4 84.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m72 74.8l5.8 12.4c0.9 2 4.4 4 6.4 4.3 2.7 0.7 10.9 2.7 14.7 2l1.6 0.4 1.2-5.4-1.7-0.4c-1.3-1.9-9.2-3.5-15.2-5.6l-4.7-12c-2.2-6.1-11.2-2.7-8.1 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m82.3 99.7c0 0 14.3-0.9 20.1-0.7 5.9 0.2 6.9 5 5.9 9.1l-10.5 25.4h-9c1.5-10.2 4-21 6.4-23-6.3 1.1-12.7 2.3-22.5 2-5.6-0.1-8.6-2.5-9-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m90.2 132l-0.9 6.8h6l1-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m89.7 135.7c0.8 1.3 2.6 1.6 6.1 0 0 0 4.7 1.5 6.9 2.4 2.1 0.8 2.9 4.1 2.9 4.1h-17.4q0.2-3.6 1.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m88.2 131.3l11.5-0.6-1 3.6h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m89.1 130.9l9.8-0.4v0.5l-9.8 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m23.5 85.7h30.7v29.9h-30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m17.2 85.8l6.3-0.1v29.9l-6.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m23.3 85.7h0.4l0.1 29.9h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m41.8 91.4v-3.5h10.1v3.4zm0.5-3v2.6h9.2v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m25.6 113.5h7.8v0.4l-7.8 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m27 109h0.5v3.7h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m26.1 110.3l-0.4-0.3 1.5-1.6 1.6 1.6-0.4 0.3-1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m31.5 109h0.5v3.7h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m30.5 110.3l-0.3-0.3 1.5-1.6 1.6 1.6-0.4 0.3-1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m18.4 87.9h2.3v0.5h-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m18.4 90.9h2.3v0.5h-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m18.4 89.4h2.3v0.5h-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m40.3 29.4h13.3l0.1 38.8h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m17.6 29.4h22.7v38.8h-22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m40 29.4h0.5v38.8h-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m19.8 34.3v-3h8.5v3zm0.5-2.5v2.1l7.7-0.1v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m45 37.5v-8.1h0.4v7.7h3.1l-0.1-7.7h0.5v8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m19.3 65.7h7.3v0.4h-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m34.7 61.2c-0.6 0-1.1-0.2-1.5-0.6-0.4-0.4-0.6-0.9-0.6-1.5v-4.8h4.2v4.8c0 0.6-0.2 1.1-0.6 1.5-0.4 0.4-0.9 0.6-1.5 0.6zm-1.7-6.4v4.3c0 0.5 0.2 0.9 0.5 1.2 0.3 0.3 0.7 0.5 1.2 0.5 0.4 0 0.8-0.2 1.2-0.5 0.3-0.3 0.4-0.8 0.4-1.2v-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m34.5 61h0.4v4.9h-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m32.6 65.7h4.2v0.4h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m25.1 68.1l33.7-0.1 0.1 17.7h-33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m14 68.1h11.1l0.1 17.6-11.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m24.9 68.1h0.5v17.6h-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m15.2 84.2v-2.2h5.2v2.2zm0.4-1.7v1.2h4.3v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m38.1 84.2v-1.7h18.7v1.6zm0.5-1.2v0.8h17.9v-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m15.1 70h5.9v0.4h-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m15.1 71.3h5.9v0.4h-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m29.3 84.2q-0.5 0-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.9v-0.7h0.5v0.7c0 0.5 0.3 0.8 0.8 0.8 0.4 0 0.8-0.3 0.8-0.8v-4.1h0.4v4.1q0 0.5-0.3 0.9c-0.3 0.2-0.6 0.4-0.9 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m26.5 79l0.2-0.3c0.6-1.4 2-2.4 3.6-2.4 1.6 0 3 1 3.7 2.4l0.1 0.3zm3.8-2.2c-1.3 0-2.4 0.7-3.1 1.8h6.2c-0.6-1.1-1.8-1.8-3.1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m47.6 69.9h9v0.5h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m19.5 85.5h37v0.4l-37 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m112.7 95.3q-0.2 0.7-0.2 1.5 0 0.7 0.2 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m118.9 89.7c-0.3 1.1-1.1 2-2.3 2.3v8.6c1.4 0.6 2.2 2 2.2 3.3 2-1.7 3.3-4.3 3.3-7.1 0-2.8-1.3-5.4-3.2-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m109.3 95.1h3.6v3.4h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m144.3 144.5c0 7.4-6 13.4-13.4 13.4-7.4 0-13.4-6-13.4-13.4 0-7.4 6-13.4 13.4-13.4 7.4 0 13.4 6 13.4 13.4zm-5.2 0c0-4.5-3.7-8.2-8.2-8.2-4.6 0-8.2 3.7-8.2 8.2 0 4.6 3.7 8.2 8.2 8.2 4.5 0 8.2-3.7 8.2-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m139.1 144.5c0 4.5-3.7 8.2-8.2 8.2-4.5 0-8.2-3.6-8.2-8.2 0-4.5 3.6-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m134.6 144.5c0 2-1.7 3.7-3.7 3.7-2 0-3.7-1.7-3.7-3.7 0-2 1.7-3.7 3.7-3.7 2 0 3.7 1.7 3.7 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m130.9 151.7c-4 0-7.2-3.2-7.2-7.2 0-1.9 0.7-3.7 2.1-5.1 1.3-1.4 3.2-2.1 5.1-2.1 1.9 0 3.7 0.7 5.1 2.1 1.4 1.4 2.1 3.2 2.1 5.1 0 4-3.2 7.2-7.2 7.2zm0-14c-1.8 0-3.5 0.7-4.8 2-1.3 1.3-2 3-2 4.8 0 3.8 3.1 6.8 6.8 6.8 3.8 0 6.8-3.1 6.8-6.8 0-1.8-0.7-3.5-2-4.8-1.3-1.3-3-2-4.8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m63.2 144.6c0 7.4-6 13.4-13.4 13.4-7.4 0-13.4-6-13.4-13.4 0-7.3 6-13.3 13.4-13.3 7.4-0.1 13.4 5.9 13.4 13.3zm-5.2 0c0-4.5-3.7-8.2-8.2-8.2-4.5 0-8.2 3.7-8.2 8.2 0 4.6 3.7 8.3 8.2 8.2 4.6 0 8.2-3.6 8.2-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m58 144.6c0 4.6-3.6 8.2-8.2 8.2-4.5 0.1-8.2-3.6-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m53.5 144.6c0 2.1-1.7 3.7-3.7 3.7-2 0-3.7-1.6-3.7-3.7 0-2 1.7-3.6 3.7-3.7 2 0 3.7 1.7 3.7 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m49.8 151.9c-4 0-7.2-3.3-7.2-7.3 0-1.9 0.7-3.7 2.1-5.1 1.3-1.3 3.2-2.1 5.1-2.1 4 0 7.2 3.2 7.2 7.2 0 4-3.2 7.3-7.2 7.3zm0-14c-1.8 0-3.5 0.7-4.8 1.9-1.3 1.3-2 3-2 4.8 0 3.8 3.1 6.8 6.8 6.8 3.8 0 6.8-3 6.8-6.8 0-3.7-3.1-6.7-6.8-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m56.5 117.7v-5.1l35-0.1-0.3 2.1c-0.3 1.7-1.8 3-3.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m56.5 117.7h-33.6c-2.1 0-4.2-0.7-5.8-2l39.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m126.4 123.6l-15.8-23.1v-6.6c0-1.4-1.2-2.6-2.6-2.6-1.4 0.1-2.5 1.2-2.5 2.6v9.4l4.8 20.4c1.5 6.3 0.4 13-3.1 18.5h-22.4l-2.8-8.9c-0.5-1.8-0.1-3.8 1.1-5.2l3.5-4.2c0.7-0.8 1-1.9 1-3v-3.3l-44.2 0.1c-8.3 5-10.5 13.4-10.5 21h31.1l8 7.3c1.4 1.4 3.4 2.3 5.4 2.3l31.6-0.1c3.5 0 6.7-1.8 8.5-4.8l3.9-3.2c3.3-2.5 7.3-4 11.4-4h10.7c-1.9-8.3-10.3-12.7-17.1-12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m62.6 136.5l-4.4-5.5c-3.1-3.7-7.6-5.8-12.4-5.8h-6.5v-0.4h6.5c4.9 0 9.6 2.2 12.7 6l4.5 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m117.5 132.4l-0.5-0.1c1.1-8.2 9.3-8.9 9.4-8.9v0.4c-0.3 0-7.9 0.7-8.9 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m85.4 144.9l-0.9-2.6 0.5-0.1 0.7 2.2h21.9v0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m63.1 118.7l24.5-0.1v0.5h-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m63.8 123.6c-0.5 0-0.9-0.4-0.9-0.9 0-0.5 0.4-0.9 0.9-0.9h7.1c0.5 0 0.9 0.4 0.9 0.9 0 0.5-0.4 0.9-0.9 0.9h-7.1zm7.1-1.4h-7.1c-0.2 0-0.4 0.2-0.4 0.5 0 0.2 0.2 0.4 0.4 0.4h7.1c0.2 0 0.4-0.2 0.4-0.4 0-0.3-0.2-0.5-0.4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m63.8 126.6q-0.3 0-0.6-0.2-0.3-0.3-0.3-0.7 0-0.3 0.3-0.6 0.3-0.3 0.6-0.3h7.1q0.3 0 0.6 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.7-0.3 0.2-0.6 0.2h-7.1zm7.1-1.3h-7.1q-0.2 0-0.3 0.1-0.1 0.1-0.1 0.3 0 0.2 0.1 0.4 0.1 0.1 0.3 0.1h7.1q0.2 0 0.3-0.2 0.1-0.1 0.1-0.3 0-0.2-0.1-0.3-0.2-0.1-0.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m63.8 129.7c-0.5 0-0.9-0.4-0.9-0.9 0-0.5 0.4-0.9 0.9-0.9h7.1c0.5 0 0.9 0.4 0.9 0.9 0 0.5-0.4 0.9-0.9 0.9h-7.1zm7.1-1.4h-7.1c-0.2 0-0.4 0.2-0.4 0.5 0 0.2 0.2 0.4 0.4 0.4h7.1c0.2 0 0.4-0.2 0.4-0.4 0-0.3-0.2-0.5-0.4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m119.3 89.1c-4.2 0.1-7.5 3.5-7.5 7.7 0 4.2 3.4 7.6 7.5 7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m105.4 103.1l5.1-2.8 0.2 0.4-5.1 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m74.5 62.3l-0.8 2.3 5.5 4.4 1.1-4c7.1 1.4 10.6-3.1 9.7-14.6l-2.9-2.9-8.7-0.7c0 0-4.4 6.3-4.3 6.5 0.1 0.1 1 5.1 1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m78.7 41.3c-5.3 0.5-9.5 4.8-10 10.1-0.4 4.7 2.1 8.9 5.8 10.9 3.4 0.1 6.2-2.7 6.2-6.1v-5.8h10.3c-1.1-5.6-6.3-9.8-12.3-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m73.6 63.9l5.8 4.4c2.5 7 4.5 27.7-0.4 31.4l-19.2 6c0 0-0.1-0.5-0.2-1.6-2.8-3-0.5-13.2 5.8-33.2 2.9-6.4 8.2-7 8.2-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m79 99.7c0 0 13.2-0.9 19.1-0.7 5.8 0.3 7.7 5.2 6.1 9.9l-9.7 24.6h-9c1.5-10.2 4-21 6.4-23-6.3 1.1-12.7 2.3-22.5 2-5.6-0.1-8.6-2.5-9-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m91.9 110.7q-0.1 0-0.2-0.1-0.1-0.1 0-0.3l1.6-2.3 0.4 0.2-1.3 1.9 1.6-0.3 0.1 0.4-2.1 0.5q-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m86.9 132l-0.9 6.8h6.1l0.9-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m86.4 135.7c0.8 1.4 2.6 1.6 6.1 0 0 0 4.8 1.5 6.9 2.4 2.2 0.8 2.9 4.1 2.9 4.1h-17.4q0.2-3.6 1.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m84.9 131.3l11.5-0.6-1 3.6h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m85.8 130.9l9.4-0.4v0.5l-9.3 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m99.5 89c0 0 4.3-1.8 6.6 0.2 2.3 1.9 1.1 4.6-0.5 4.4-1.6-0.1-5.1-0.3-5.1-0.3-0.6 0.2-1.2-0.1-1.9-0.6-2.5-0.8-1.8-5 0.9-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m105.8 93.1c0 1.5-1.2 2.6-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.6 2.7-2.6 1.4-0.1 2.6 1.1 2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m66.2 74.8l6.5 12.4c1.1 2 5 4 7.2 4.3 3.1 0.7 12.3 2.7 16.5 2l1.8 0.4 1.4-5.3-2-0.5c-1.4-1.9-10.2-3.4-17-5.6l-5.2-12c-2.5-6.1-12.6-2.7-9.2 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m79.4 68.3c0 0-5.9-6.8-9.4-6.8-3.5 0-9.3 8-5.5 12.5 1.5-3.2 5-8.6 8-8.6 3 0.1 6.9 2.9 6.9 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m96.2 93.4l1.2-5.3 0.5 0.1-1.3 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m60.1 105.6q0.1 1.1 0.5 2.1l18.4-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m80.2 65.2c-1.7-0.8-2-1.8-2-1.9l0.4-0.1-0.2 0.1 0.2-0.1c0 0 0.3 0.9 1.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m80.7 55.8l1.2-4.7c0 0 12 5.9 9.5-4.4-0.4 2.8-1.9 3.7-6 3.7h-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m77.2 60.8l-0.2-0.4c2.1-0.9 2.8-4.3 2.1-10v-0.2h1.6v0.4h-1.1c0.7 5.8-0.1 9.2-2.4 10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m81.8 92.1c-12.2-1.7-14.7-15.1-14.7-15.2l0.4-0.1c0 0.2 2.5 13.2 14.3 14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m81.7 83.1c-2.1-2.2-4.4-7.4-6.1-11.7l0.4-0.1c1.7 4.2 4 9.3 6 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m79.7 84.8l-0.4-0.1q0.7-2 2.5-2.1 0.2 0 0.2 0.1 0.1 0.1 0 0.3-0.6 0.6-0.5 1.7l-0.5 0.1q-0.1-1 0.3-1.7-1.1 0.3-1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m59.5 103.9l19.5-4.4 0.1 0.5-19.5 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m74.5 23.8h82.2c-10.9-5.6-17.5-7.7-20.8-3.7 1-7.3-7.5-12.5-13.7-6.6-4.6-9.7-13.2-9-19 2.9-3.4-3.8-9.2-2.9-10.7 4-2.5-3.2-7.2-1.3-18 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m26.8 9.9h38.7c-5.8-4.8-9.6-6-11.2-3.4-2.5-7.2-11.8-7.7-15.5 0-2.8-1.9-6.7-1.2-12 3.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2c379aec49173757aa7b7cbcd865061a.svg";
export { ForwardRef as ReactComponent };